import React from 'react';
import PropTypes from 'prop-types';

import {Accordion, AccordionSummary, AccordionDetails, Stack, Button, Typography, Box} from 'views/components';

import {Translate, translate, ReactToPrint} from 'views/module';

import moment from 'moment';

import SlipHourOverview from './SlipHourOverview';
import SlipHourDetails from './SlipHourDetails';

const SlipView = (props) => {
  const [isCompleting, setIsCompleting] = React.useState(false);
  const [isExpanded, setIsExpanded] = React.useState(false);
  const printableRef = React.useRef(null);

  const {slipDetail, clientBackend} = props;
  const {weekOf, status} = slipDetail;

  const weekOfDisplay = moment(weekOf, 'YYYY[Week]WW').format('YYYY-MM-DD');

  const handleComplete = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsCompleting(true);
    clientBackend.payment.markAsComplete(weekOf);
  };

  return (
    <Stack spacing={1}>
      <Accordion
        elevation={0}
        expanded={isExpanded}
        onChange={(event, isExpanded) => setIsExpanded(isExpanded)}
        sx={{width: 1}}
        disableGutters
      >
        <AccordionSummary>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            sx={{width: '100%'}}
            className="no-print"
          >
            <Typography
              sx={{
                fontWeight: 'bold',
              }}
            >
              <Translate
                expression="client.ClientDetail.Payment.WeekOf"
                substitute={{
                  date: weekOfDisplay,
                  status: status === 'IN_PROGRESS' ?
                    translate('client.ClientDetail.Payment.WaitingConfirmation') :
                    translate('client.ClientDetail.Payment.Complete'),
                }}
              />
            </Typography>
            <Stack direction="row" spacing={1}>
              <ReactToPrint
                printableRef={printableRef}
                documentTitle={`PaymentSlip_${weekOfDisplay}_${slipDetail?.hours?.[0]?.client?.clientDetail?.clientName}`}
              />
              {
                status === 'IN_PROGRESS' &&
                <Button onClick={handleComplete} variant="contained" loading={isCompleting}>
                  <Translate
                    expression="client.ClientDetail.Payment.Complete"
                  />
                </Button>
              }
            </Stack>
          </Stack>
        </AccordionSummary>
        <AccordionDetails>
          {/* Printable content */}
          <Box ref={printableRef}>
            <SlipHourOverview slipDetail={slipDetail} />
            <SlipHourDetails slipDetail={slipDetail} />
          </Box>
        </AccordionDetails>
      </Accordion>
    </Stack>
  );
};

SlipView.propTypes = {
  slipDetail: PropTypes.object.isRequired,
  clientBackend: PropTypes.object.isRequired,
};

export default React.memo(SlipView);
